import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CaisService {

  private URL = environment.api + "api/erp/cais";

  constructor(private http: HttpClient) { }

  generateFiscalDocument(invoiceId: number) {
    return this.http.get(this.URL + `/by-provider-invoice/${invoiceId}`);
  }
}



